import React, { useEffect, useState } from "react";
import { getLoginPage } from "./Hooks";

const NoticeLogin = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(false);
      const result = await getLoginPage("00000000-0000-0000-0000-000000000000");
      setData(result);
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) return null;

  return (
    <div className="login-banner">
      <div className="img-slide">
        {data?.imageUrl && (
          <img src={data?.imageUrl} alt={data?.imageName} />
        )}
      </div>
      <div className="text-banner">
        <div dangerouslySetInnerHTML={{ __html: data?.description }} />
      </div>
    </div>
  );
};

export default NoticeLogin;
